// approximate swatch for common Brazilian MDF names; unknown names get a neutral dashed swatch
const TONES = [
  [/preto|black|onix|ônix|grafite escuro/, "#1F1F1F"],
  [/grafite|chumbo|titanio|titânio/, "#4B4F55"],
  [/cinza|cristal|gris|concreto|cimento/, "#9CA3AF"],
  [/branco|white|neve|polar|ártico|artico/, "#F5F5F0"],
  [/off|areia|bege|linho|cru|pérola|perola|marfim/, "#E6DCC8"],
  [/carvalho|oak|malva/, "#B98E5C"],
  [/freij|louro|tauari/, "#C29A62"],
  [/nogueira|walnut|tabaco|castanho|imbuia/, "#6B4A2F"],
  [/cedro|cerejeira|mogno|amendoa|amêndoa|canela/, "#9A5B3A"],
  [/pinus|pinho|natural|bétula|betula|marfim/, "#D9B98A"],
  [/azul|blue|marinho/, "#2F5D8A"],
  [/verde|green|oliva|salvia|sálvia/, "#5E7B5A"],
  [/vermelho|red|vinho|bordo|bordô/, "#8B2E2E"],
  [/amarelo|yellow|mostarda/, "#D4A72C"],
  [/rosa|pink|terracota/, "#C98B7A"],
];

export const mdfTone = (name) => {
  const n = (name || "").toLowerCase();
  return TONES.find(([re]) => re.test(n))?.[1] || null;
};

export const ColorSwatch = ({ name, size = 12, testId }) => {
  const c = mdfTone(name);
  return (
    <span data-testid={testId} title={c ? name : `${name || "Sem cor"} (cor não reconhecida)`}
      className="inline-block shrink-0 rounded-[3px] align-middle"
      style={{ width: size, height: size, background: c || "transparent", border: c ? "1px solid rgba(128,128,128,.6)" : "1px dashed #6B7280" }} />
  );
};
